<div fxLayout="column" class="container">
    <div class="dialog-title">
        <span>{{title}}</span>
    </div>

    <div fxLayout="column" class="back-white">
        <div class="dialog">
            {{dialog}}
        </div>
    
        <div class="buttons" fxLayout="row" fxLayoutAlign="space-around">
            <button
            *ngIf="cancelButtonString"
            class="button secondary-button"
            (click)="onCancel()">
                {{cancelButtonString}}
            </button>
    
            <button 
            *ngIf="okButtonString"
            class="button primary-button"
            (click)="onSubmit()"> 
                {{okButtonString}}
            </button>
        </div>
    </div>

    
</div>